<div class="w-full">
  <button cdkOverlayOrigin #triggerBtn="cdkOverlayOrigin" type="button" (click)="isCalendarOpen.set(!isCalendarOpen())"
    class="relative h-12 w-full bg-gray-100 text-gray-500 rounded-full flex items-center gap-1 text-sm font-medium">
    <div class="absolute top-1/2 -translate-y-1/2 pl-2 lg:pl-4">
      <icon-calendar [size]="18" />
    </div>
    <div class="pl-8 lg:pl-10 h-full w-full flex items-center justify-start">
      {{ selectedDate() ? (selectedDate() | date : 'd MMMM yyy') : 'Pick a date' }}
    </div>
  </button>

  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="triggerBtn" [cdkConnectedOverlayOpen]="isCalendarOpen()"
    cdkConnectedOverlayWidth="auto" (overlayOutsideClick)="isCalendarOpen.set(false)">
    <div class="bg-white translate-y-2.5 border border-gray-200 rounded-md text-xs font-medium">
      <div class="p-2 flex items-center justify-between gap-10">
        <button (click)="prev()" class="p-1 flex items-center justify-center border border-gray-200">
          <icon-arrow-left [size]="18" />
        </button>
        <div class="w-[140px] flex items-center justify-center">
          <button (click)="toggleViewMode()" class="flex items-center gap-0.5 hover:text-gray-500">
            <span>
              @if (viewMode() === 'months') {
              {{ currentDate() | date: 'MMMM yyyy' }}
              } @else {
              <span> {{ yearsRange[0] }} - {{ yearsRange[yearsRange.length - 1] }}</span>
              }
            </span>
            <icon-arrow-down [size]="16" />
          </button>
        </div>
        <button (click)="next()" class="p-1 flex items-center justify-center border border-gray-200">
          <icon-arrow-right [size]="18" />
        </button>
      </div>

      @if (viewMode() === 'months') {
      <div class="flex p-2">
        <table class="w-full">
          <thead>
            @for (day of daysOfWeek; track $index) {
            <th class="h-8">
              <div class="text-gray-700">{{ day }}</div>
            </th>
            }
          </thead>
          <tbody>
            @for (week of calendarDays; track $index) {
            <tr>
              @for (day of week; track $index) {
              <td>
                <button type="button" (click)="selectDate(day.date)"
                  class="w-9 h-8 rounded flex items-center justify-center hover:bg-gray-200" [ngClass]="{
                        'text-gray-400': day.outside,
                        'bg-gray-300 hover:bg-gray-400': day.date.toLocaleDateString() === today.toLocaleDateString(),
                         'bg-main-500 text-white hover:bg-main-600': selectedDate() && day.date.toLocaleDateString() === selectedDate()!.toLocaleDateString()
                        }">
                  {{ day.date.getDate() }}
                </button>
              </td>
              }
            </tr>
            }
          </tbody>
        </table>
      </div>
      } @else {
      <div class="p-2">
        <div class="grid grid-cols-4 gap-0.5">
          @for (year of yearsRange; track $index) {
          <button (click)="selectYear(year)"
            class="h-11 flex items-center justify-center rounded text-gray-700 hover:bg-gray-200 transition-colors"
            [ngClass]="{
                  'bg-gray-300 hover:bg-gray-400': year == today.getFullYear(),
                  'bg-main-500 text-white hover:bg-main-600': selectedDate() && year === selectedDate()!.getFullYear() && year !== today.getFullYear()
                  }">
            {{ year }}
          </button>
          }
        </div>
      </div>
      }
    </div>

  </ng-template>
</div>